export default {
  render: {
    hint: {
      blankCellContent: '--',
      cancel: '取消',
      confirm: '确定',
      datePlaceholder: '选择日期',
      defaultActiveText: '是',

      defaultInactiveText: '否',
      deleteSubFormRow: '删除行',
      downloadFile: '下载',
      endDatePlaceholder: '截止日期',
      endTimePlaceholder: '截止时间',
      fieldRequired: '字段值不可为空',
      fileSizeExceed: '文件大小已超出: ',
      insertSubFormRow: '插入行',

      invalidNumber: '数据格式错误',
      nonSubFormType: '组件类型不是子表单',
      prompt: '提示',
      refNotFound: '组件未找到: ',
      removeFile: '移除',
      selectFile: ' 选择文件',
      selectPlaceholder: '请选择',
      startDatePlaceholder: '起始日期',
      startTimePlaceholder: '起始时间',
      subFormAction: '操作',
      subFormAddAction: '新增',

      subFormAddActionHint: '新增行',
      subFormRowNo: '行号',
      timePlaceholder: '选择时间',
      unsupportedFileType: '不支持格式: ',
      uploadError: '上传错误: ',
      uploadExceed: '最大上传数量(${uploadLimit})已超出.',
      validationFailed: '表单数据校验失败',
    },
  },
};
